/**
 * Slider Partners script
 */
class Bookero_SliderPartners {
  constructor (wrapper) {
    this.sliderWrapper = wrapper;  
    this.initState();
    this.initEvents();
  }

  initState () {
		this.dots = this.sliderWrapper.find('.dot');
		this.prevBtn = this.sliderWrapper.find('.prev');
		this.nextBtn = this.sliderWrapper.find('.next');
		this.list = this.sliderWrapper.find('.slider-partners-list');
		this.items = this.list.find('.slider-partners-item');
		this.itemsPerPage = 7;
		this.currentItem = 0;
		this.animationInProgress = false;
  }

  initEvents () {
    this.initRWD();
    this.initUI();
  }

  initUI () {
		this.swipeEffect = new Hammer(this.sliderWrapper[0]);

		if (this.items.length <= this.itemsPerPage) {
			this.prevBtn.addClass('is-hidden');
			this.nextBtn.addClass('is-hidden');
		}

		for (let i = 0; i < this.dots.length; i++) {
			this.dots.eq(i).on('click', e => {
				e.preventDefault();

				if (this.animationInProgress) {
					return;
				}

				this.currentItem = i;
				this.animationInProgress = true;
				this.dots.removeClass('is-active');
				this.dots.eq(this.currentItem).addClass('is-active');

				this.items.addClass('is-hidden');
				this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");

				setTimeout(() => {
					this.animationInProgress = false;
				}, 100);
			});
		}

		this.nextBtn.on('click', e => {
			e.preventDefault();

			if (this.animationInProgress) {
				return;
			}

			this.currentItem++;
			this.animationInProgress = true;

			if (this.currentItem >= this.items.length - (this.itemsPerPage - 1)) {
				this.currentItem = 0;
			}

			this.dots.removeClass('is-active');
			this.dots.eq(this.currentItem).addClass('is-active');
			this.list.css('margin-left', (-(100 / this.itemsPerPage) * this.currentItem) + "%");

			setTimeout(() => {
				this.animationInProgress = false;
			}, 550);
		});


		this.prevBtn.on('click', e => {
			e.preventDefault();

			if (this.animationInProgress) {
				return;
			}

			this.currentItem--;
			this.animationInProgress = true;

			if (this.currentItem < 0) {
				this.currentItem = this.items.length - this.itemsPerPage;
			}

			this.dots.removeClass('is-active');
			this.dots.eq(this.currentItem).addClass('is-active');
			this.list.css('margin-left', ((-100 / this.itemsPerPage) * this.currentItem) + "%");

			setTimeout(() => {
				this.animationInProgress = false;
			}, 550);
		});

		this.swipeEffect.on('swipe', ev => {
			if (ev.type === 'swipe' && ev.direction === 2) {
				if (this.currentItem < this.dots.length - 1) {
					this.currentItem++;
				} else {
					this.currentItem = 0;
				}

				this.dots.eq(this.currentItem).trigger('click');
			}

			if (ev.type === 'swipe' && ev.direction === 4) {
				if (this.currentItem > 0) {
					this.currentItem--;
				} else {
					this.currentItem = this.dots.length - 1;
				}

				this.dots.eq(this.currentItem).trigger('click');
			}
		});
  }

  initRWD () {
		let desktopViewport = window.matchMedia('(min-width: 1600px)');
		let smallDesktopViewport = window.matchMedia('(min-width: 1024px) and (max-width: 1599px)');
		let tabletViewport = window.matchMedia('(min-width: 720px) and (max-width: 1023px)');
		let mobileViewport = window.matchMedia('(max-width: 719px)');

		if (desktopViewport.matches) {
				this.itemsPerPage = 7;
		} else if (smallDesktopViewport.matches) {
			this.itemsPerPage = 4;
		} else if (tabletViewport.matches) {
				this.itemsPerPage = 3;
		} else if (mobileViewport.matches) {
				this.itemsPerPage = 2;
		}

		this.toggleDotsVisibility();

		desktopViewport.addListener(mq => {
			if (mq.matches) {
				this.setItemsPerPage(7);
			}
		});

		smallDesktopViewport.addListener(mq => {
			if (mq.matches) {
				this.setItemsPerPage(4);
			}
		});

		tabletViewport.addListener(mq => {
			if (mq.matches) {
				this.setItemsPerPage(3);
			}
		});

		mobileViewport.addListener(mq => {
			if (mq.matches) {
				this.setItemsPerPage(2);
			}
		});
  }

	setItemsPerPage (numberOfItems) {
		this.currentItem = 0;
		this.itemsPerPage = numberOfItems;
		this.dots.removeClass('is-active');
		this.dots.eq(this.currentItem).addClass('is-active');
		this.list.css('margin-left', (-100 * this.currentItem) + "%");
		this.toggleDotsVisibility();
	}

	toggleDotsVisibility () {
		let visibleDots = this.items.length - this.itemsPerPage;

		for (let i = 0; i < this.dots.length; i++) {
			let visibilityState = i <= visibleDots ? 'block' : 'none';
			this.dots.eq(i).css('display', visibilityState);
		}
	}
}
